import ResolvePopup from './ResolvePopup.component';

export default ResolvePopup;
